export enum EventStatus {
    Pending = 100,
    Live = 200,
    Expired = 300,
    Cancelled = 400,
    Full = 500
}

export enum BookingStatus {
    Pending = 100,
    Paid = 200,
    Cancelled = 300
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/training/training.enums.ts